import React from 'react';

const InvestmentPreferences = ({ allocatorProfile }) => {
  return <div>{allocatorProfile.investmentCriteria}</div>;
};

export default InvestmentPreferences;
